<img
  src="https://web.glance-cdn.com/images/desk_uploads/header_logo.png"
  alt="glance"
  height="21"
/>
